import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiVisa } from '../../shared';
import { Pagination, PagingResponseModel } from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class RmaReportService extends BaseApiTemplateService<any> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/rma-reports';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/rma-reports';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'svc/rma-reports';
    this.httpClient = http;
  }

  getByCriteriaListing(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/listing/backoffice-ep?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}